import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Menu, X, PieChart } from 'lucide-react';
import { cn } from '../lib/utils';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300', isScrolled ? 'bg-white/80 backdrop-blur-md border-b border-slate-200 py-3' : 'bg-transparent py-5')} data-id="element-49">
      <div className="container mx-auto px-4 md:px-6" data-id="element-50">
        <div className="flex items-center justify-between" data-id="element-51">
          <div className="flex items-center gap-2" data-id="element-52">
            <div className="bg-blue-600 p-1.5 rounded-lg" data-id="element-53">
              <PieChart className="h-6 w-6 text-white" data-id="element-54" />
            </div>
            <span className="text-xl font-bold tracking-tight text-slate-900" data-id="element-55">
              CreditArea
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-56">
            <a href="#how-it-works" className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-57">
              Cum funcționează
            </a>
            <a href="#benefits" className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-58">
              Beneficii
            </a>
            <a href="#faq" className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-59">
              Întrebări
            </a>
          </div>

          <div className="hidden md:flex items-center gap-4" data-id="element-60">
            <Button variant="ghost" size="sm" data-id="element-61">
              Autentificare
            </Button>
            <Button size="sm" data-id="element-62">Începe acum</Button>
          </div>

          {/* Mobile Toggle */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-63">
            {isMobileMenuOpen ? <X data-id="element-64" /> : <Menu data-id="element-65" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-white border-b border-slate-200 p-4 md:hidden shadow-lg animate-in slide-in-from-top-5" data-id="element-66">
          <div className="flex flex-col gap-4" data-id="element-67">
            <a href="#how-it-works" className="text-base font-medium text-slate-600 py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-68">
              Cum funcționează
            </a>
            <a href="#benefits" className="text-base font-medium text-slate-600 py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-69">
              Beneficii
            </a>
            <a href="#faq" className="text-base font-medium text-slate-600 py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-70">
              Întrebări
            </a>
            <div className="h-px bg-slate-100 my-2" data-id="element-71" />
            <Button variant="ghost" className="w-full justify-start" data-id="element-72">
              Autentificare
            </Button>
            <Button className="w-full" data-id="element-73">Începe acum</Button>
          </div>
        </div>}
    </nav>;
}